import { createContext, useContext, useEffect, useState } from 'react';

const LoginContext = createContext<any>({
  user: null,
  setUser: (user: any) => {},
  logout: () => {},
});

export const useLogin = () => {
  return useContext(LoginContext);
};

export const LoginProvider: any = ({ children }: any) => {
  const [user, saveUser] = useState<any>();

  const setUser = (user: any) => {
    localStorage.setItem('token', user?.token);
    localStorage.setItem('user_id', user?.user_id);
    localStorage.setItem('role_id', user?.role_id);
    localStorage.setItem('user', JSON.stringify(user));
    localStorage.setItem('uuid', user?.uuid);
    localStorage.setItem('bar_no', user?.bar_no);
    if (!user.user_id) {
      user.user_id = 1;
    }

    saveUser(user);
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user_id');
    localStorage.removeItem('uuid');
    localStorage.removeItem('role_id');
    localStorage.removeItem('user');
    localStorage.removeItem('bar_no');
    saveUser(undefined);
  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    const user_id = localStorage.getItem('user_id');
    const uuid = localStorage.getItem('uuid');
    const role_id = localStorage.getItem('role_id');
    saveUser((user: any) => {
      return { ...user, token, user_id, uuid, role_id: role_id || '1' };
    });
  }, []);

  return (
    // @ts-ignore
    <LoginContext.Provider value={{ user, setUser, logout }}>{children}</LoginContext.Provider>
  );
};
